import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Episode from './Episode';
import TrackData from './TrackData';
// import _ from 'lodash'
import { DateTime } from "luxon";

import {
  onAirFM, onAirZD, programEpisodeWithPlaylist, fmLineup
} from '~/programs/actions'
import OnAirProgram from '~/programs/components/OnAirProgram';


const Lineup = (props) =>  {
  const { programs, programsFM, dispatch } = props

  useEffect( () => {
    let interval = null;
    interval = setInterval(getNP, 600000)
    // getNP();
    
    return () => {
      clearInterval(interval);
    }
  }, []);

  const getNP = () => {
    Promise.all([
      dispatch(onAirFM()),
      dispatch(onAirZD())
    ]).then(dispatch(fmLineup()))
  }

  const showsGuide = programsFM.lineup.map((item, index) => {
    var episode, playlist
    let nowDate = DateTime.local().setZone("Australia/Brisbane").toISODate();

    if (programs &&
      programs[item.slug] &&
      programs[item.slug].playlists
    ) {
      if(programs[item.slug].playlists[`${nowDate} ${item.start}`] && programs[item.slug].playlists[`${nowDate} ${item.start}`].items ) {
        episode = programs[item.slug].episodes[`${nowDate} ${item.start}`]
        playlist = programs[item.slug].playlists[`${nowDate} ${item.start}`]
      }
    }
    return (
      <OnAirProgram key={index} program={item} episode={episode} playlist={playlist} onairnow={item.onairnow} title={item.title} height={item.height} reverse={item.reverse}/>
    )
  })

  return (
    <div>
      {showsGuide}
    </div>
  )
}

Lineup.fetchData = (store, route, match) => {
  return Promise.all([
    store.dispatch(onAirFM()),
    store.dispatch(onAirZD())
  ])
}

export default connect(state => ({programs: state.programs, programsFM: state.programsFM, onAirFM: state.onAirFM})) (Lineup)
